<template>
  <div>
    <SelectedCategoriesBubble
      :isAdminPage="isAdminPage"
      :subCategoryIds="this.competition.fundId.selectedSubCategories"
    />

    <p v-show="competition.fundId.productData.productDescription && showOnAdminPageOnly" class="mt-3">
      <b>Termék leírása: </b>
      {{ competition.fundId.productData.productDescription }}
    </p>

    <FundRequestTime
      title="Igénylési időszak"
      :requestStartDate="competition.fundId.appearanceDate.requestStartDate"
      :requestEndDate="competition.fundId.appearanceDate.requestEndDate"
      :availableUntilFundIsExhausted="competition.fundId.appearanceDate.availableUntilFundIsExhausted"
    />
    <FundRequestTime
      v-if="showOnAdminPageOnly"
      title="Megjelenési időszak"
      :requestStartDate="competition.fundId.appearanceDate.appearanceStartDate"
      :requestEndDate="competition.fundId.appearanceDate.appearanceEndDate"
    />

    <p v-show="competition.fundId.productData.linkToProduct && showOnAdminPageOnly" class="mt-3">
      <b>Link a termékhez: </b>
      <a :href="competition.fundId.productData.linkToProduct">{{ competition.fundId.productData.linkToProduct }}</a>
    </p>

    <p
      v-show="
        competition.fundId.applicationData.applicationMin || competition.fundId.applicationData.applicationMin === 0
      "
      class="mt-3"
    >
      <b>Támogatási összeg minimuma:</b>
      {{ numberWithDots(competition.fundId.applicationData.applicationMin) + ' HUF' }}
    </p>
    <p
      v-show="
        competition.fundId.applicationData.applicationMax || competition.fundId.applicationData.applicationMax === 0
      "
      class="mt-3"
    >
      <b>Támogatási összeg maximuma:</b>
      {{ numberWithDots(competition.fundId.applicationData.applicationMax) + ' HUF' }}
    </p>
    <p v-show="competition.fundId.applicationData.determineAmount" class="mt-3 mb-1">
      <b>Összeg megállapításának módja:</b> {{ competition.fundId.applicationData.determineAmount }}
    </p>
    <p v-show="competition.fundId.applicationData.selfContribution" class="mt-3">
      <b>Önerő:</b> {{ competition.fundId.applicationData.selfContribution }}
    </p>
    <p v-show="competition.fundId.applicationData.intensivityOfApplication" class="mt-3">
      <b>Támogatás intenzitás:</b>
      {{ competition.fundId.applicationData.intensivityOfApplication }}
    </p>

    <p class="mt-3">
      <b>Előminősítés:</b>
      {{ competition.fundId.preQualification && competition.fundId.preQualification.isActive ? 'Van' : 'Nincs' }}
      <span
        v-if="competition.fundId.preQualification && competition.fundId.preQualification.isActive"
        class="router-link"
        @click="handleOfferLink(competition.fundId.preQualification.link)"
        >Tovább az előminősítésre</span
      >
    </p>
    <p
      v-show="competition.fundId.preQualification.startDate && competition.fundId.preQualification.endDate"
      class="mt-3"
      v-if="competition.fundId.preQualification && competition.fundId.preQualification.isActive"
    >
      <b>Előminősítés időszak:</b>

      {{ formatDate(competition.fundId.preQualification.startDate) }} -
      {{ formatDate(competition.fundId.preQualification.endDate) }}
    </p>
    <p class="mt-3">
      <b>Regisztráció:</b>
      {{ competition.fundId.preRegistration && competition.fundId.preRegistration.isActive ? 'Van' : 'Nincs' }}
      <span
        v-if="competition.fundId.preRegistration && competition.fundId.preQualification.isActive"
        class="router-link"
        @click="handleOfferLink(competition.fundId.preQualification.link)"
        >Tovább az regisztrációhoz</span
      >
    </p>
    <p
      v-show="competition.fundId.preRegistration.startDate && competition.fundId.preRegistration.endDate"
      class="mt-3"
      v-if="competition.fundId.preRegistration && competition.fundId.preRegistration.isActive"
    >
      <b>Regisztrációs időszak:</b>
      {{ formatDate(competition.fundId.preRegistration.startDate) }}-
      {{ formatDate(competition.fundId.preRegistration.endDate) }}
    </p>
    <div v-show="competition.fundId.guarantee.uniqueConditions.length > 0" class="mt-3">
      <b
        v-if="
          competition.fundId.guarantee.uniqueConditions[0] &&
            competition.fundId.guarantee.uniqueConditions[0].condition.length > 0
        "
        >Egyedi feltételek, kizárások:</b
      >
      <p class="mt-1" v-for="item in competition.fundId.guarantee.uniqueConditions" :key="item.id">
        {{ item.condition }}
      </p>
    </div>
  </div>
</template>

<script>
import FundRequestTime from '../../../../components/FundRequestTime.vue'
import SelectedCategoriesBubble from './SelectedCategoriesBubble.vue'
export default {
  props: {
    competition: { type: Object, required: true }
  },
  data() {
    return {
      isAdminPage: false
    }
  },
  computed: {
    showOnAdminPageOnly() {
      return this.$route.path.includes('/competitions/details')
    }
  },
  methods: {
    numberWithDots(number) {
      if (!this.fieldIsEmpty(number)) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },

    handleOfferLink(link) {
      const win = window.open(link, '_blank')
      win.focus()
    },
    fieldIsEmpty: function(field) {
      return field === '' || field === null || field === undefined
    },
    formatDate: function(date) {
      if (!date) {
        return 'N/A'
      }
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('.')
    }
  },
  components: { FundRequestTime, SelectedCategoriesBubble },
  created() {
    if (this.$route.path.includes('fund-map')) {
      this.isAdminPage = false
    } else {
      this.isAdminPage = true
    }
  }
}
</script>

<style lang="scss" scoped>
.router-link {
  color: #00903c;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    color: #1d7d46;
  }
}
</style>
